import { Reveal } from "@/components/Reveal";
import { FaqAccordion } from "@/components/FaqAccordion";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <section className="mx-auto max-w-3xl px-5 pt-16 lg:pt-24">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">FAQ</p>
          <h1 className="mt-4 font-display text-5xl font-extrabold tracking-tighter sm:text-6xl">Everything you need to know.</h1>
        </Reveal>
        <div className="mt-12 pb-24 lg:pb-32"><FaqAccordion /></div>
      </section>
    </div>
  );
}
